// extracted by mini-css-extract-plugin
module.exports = {"StatusInfoPanel":"StatusInfoPanel_StatusInfoPanel__2cN44","col":"StatusInfoPanel_col__3ITHY"};